<template>
  <div class="maintenance-feedback">
    <header>
      <div class="title">提交反馈</div>
    </header>
    <section>
      <div class="title-img">
        <div class="img-box">
          <img src="@/assets/maintenance/feedback_icon_2.png" />
        </div>
      </div>
      <div class="content">
        <!-- 反馈内容 -->
        <div class="content-title">
          <div class="mark">*</div>
          <div class="title">反馈内容</div>
          <div class="english">Contact The Manuscript</div>
        </div>
        <textarea
          class="feedback"
          required="required"
          v-model="content"
          placeholder="请输入反馈内容"
        ></textarea>
        <!-- 手机号码 -->
        <div class="content-title">
          <div class="mark">*</div>
          <div class="title">手机号码</div>
          <div class="english">Mobile Phone</div>
        </div>
        <input
          type="text"
          class="inp"
          v-model="mobile"
          required="required"
          placeholder="请输入您的手机号码"
          maxlength="11"
        />
        <div class="remarks">
          注：为了便于对您的车辆提供最佳机油推荐，麻烦提供一下手机号，便于我们后续改进
        </div>
        <!-- 地址 -->
        <div class="content-title">
          <div class="title">收货地址</div>
          <div class="english">Address</div>
        </div>
        <div class="region-input" @click="showPopup">
          <div class="value" v-if="raw_region[0]">
            {{ raw_region[0].name }} {{ raw_region[1].name }}
            {{ raw_region[2].name }}
          </div>
          <div class="place-holder" v-else>选择所在地区</div>
          <div class="more">
            <img
              src="https://select-oil-oss.vchangyi.com/wxapp/home-gray-arrow-right-icon.png"
            />
          </div>
        </div>
        <textarea
          class="address-textarea"
          required="required"
          v-model="address_textarea"
          placeholder="请输入您的详细地址"
        ></textarea>
        <div class="remarks" style="color: #d51317">
          注：感谢您的反馈，优质留言者将会收到壳牌提供的精美礼品一份
        </div>
        <!-- 上传图片 -->
        <div class="content-title subtitle">
          <div class="title">图片上传</div>
          <div class="english">Image upload</div>
        </div>
        <div class="imgs-box">
          <div class="item" v-for="(item, index) in imgList" :key="index">
            <i
              class="iconfont icon-quxiaoglyph_ font-12"
              @click="deleteImage(index)"
            ></i>
            <img :src="item" alt @click="previewImage(item)" />
          </div>
          <div
            class="upload item"
            v-upfiled="config"
            v-show="imgList.length < 5"
          >
            <img class="upload-img" src="@/assets/maintenance/add_img.png" />
          </div>
        </div>
      </div>
    </section>
    <footer>
      <div class="btn" @click="submit">提交</div>
    </footer>
    <van-popup v-model="region_visible" round position="bottom">
      <van-area
        :value="region"
        :area-list="areaList"
        @confirm="areaConfirm"
        @cancel="closePopup"
      ></van-area>
    </van-popup>
  </div>
</template>

<script>
import api from "@/apis/maintenance-api";
import wx from "weixin-js-sdk";
import { Area, Popup } from "vant";
import { areaList } from "@vant/area-data";
export default {
  name: "maintenance-feedback",
  components: { VanArea: Area, VanPopup: Popup },
  data() {
    return {
      areaList,
      imgList: [],
      focus: false,
      inputFocus: false,
      content: "",
      mobile: "",
      iswx: this.browser.wx,
      config: {
        url: `${window.VUE_APP_API_ROOT}oil/common/upload`,
        size: "6",
        fileType: ["jpg", "png", "jpeg", "gif", "bmp"],
        multiple: false,
        atMediatype: "99",
        params: {},
        callback: this.uploadcall,
      },
      region_visible: false,
      region: "",
      raw_region: [],
      address_textarea: "",
    };
  },
  mounted() {
    if (this.browser.wx == 1) {
      wx.ready(function () {
        wx.hideAllNonBaseMenuItem();
      });
    }
  },

  methods: {
    // 图片预览
    previewImage(atAttachment) {
      this.imgpreview(atAttachment, this.imgList);
    },
    showPopup() {
      this.region_visible = true;
    },
    closePopup() {
      this.region_visible = false;
    },
    areaConfirm(res) {
      console.log(res);
      this.region = res[2].code;
      this.raw_region = res;
      this.region_visible = false;
    },
    // 图片删除
    deleteImage(index) {
      this.imgList.splice(index, 1);
    },

    // 提交反馈
    submit() {
      var self = this;
      let toast = this.$toast;
      if (!self.content) {
        toast.show({
          showTime: 3,
          message: "请输入提交内容",
          style: "error",
        });
        return false;
      }
      if (!/^1[23456789]\d{9}$/.test(self.mobile)) {
        toast.show({
          showTime: 3,
          message: "请填写正确的手机号码",
          style: "error",
        });
        return false;
      }
      self.$loading.show("提交中...");
      api
        .feedbackApi({
          content: self.content,
          mobile: self.mobile,
          url: self.imgList,
          scheme_id: window.sessionStorage.getItem("OILVERSION"),
          address:
            self.raw_region.map((i) => i.name).join("") + self.address_textarea,
        })
        .then((data) => {
          if (data.code == 0) {
            toast.show({
              showTime: 3,
              message: "提交成功",
              style: "success",
            });
            self.$router.go(-1);
          } else {
            toast.show({
              showTime: 3,
              message: data.message,
              style: "error",
            });
          }
          self.$loading.hide();
        });
    },

    // 图片上传成功之后的回调
    uploadcall(res) {
      if (res.code == 0) {
        this.imgList = this.imgList.concat([res.data.url]);
      } else {
        this.$toast.show({
          showTime: 3,
          message: "上传失败，请重试",
          style: "error",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../style/page/maintenance/feedback.less";
</style>
